import { isMyWMApp } from "utils-lib/isMyWMApp"
import MyWMPhoneInput from "./MyWMPhoneInput"
import AEMPhoneInput from "./AEMPhoneInput"

export default isMyWMApp ? MyWMPhoneInput : AEMPhoneInput
